export interface GamePlayGameId {
  readonly gamePlayId: string
  readonly gameId: string
}

export const gamePlayGameIdNull: GamePlayGameId = {
  gamePlayId: '',
  gameId: '',
}
